import { makeEndpointFns } from '../fns';
import {
    ImageClassificationModel,
    ImageClassificationModelUploadRequest,
    ImageClassificationModelUpdateRequest,
    ImageClassificationModelConfigs,
} from '@whiz-cart/node-shared/models/imageClassificationsUpload/imageClassifications';

const { GET, PUT, PATCH, DELETE } = makeEndpointFns('storeManager');

export const imageClassificationModels = {
    /** List all models */
    listModels: GET('api/v1/imageClassification', ImageClassificationModel.array()),

    /** List model configs */
    configs: GET('api/v1/imageClassification/config', ImageClassificationModelConfigs),

    /** Create & upload a new model */
    uploadModel: PUT('api/v1/imageClassification', ImageClassificationModel, {
        body: ImageClassificationModelUploadRequest,
    }),

    /** Update the stores and/or environments of an existing model */
    updateModel: PATCH('api/v1/imageClassification', ImageClassificationModel, {
        body: ImageClassificationModelUpdateRequest,
    }),

    /** Delete a model */
    deleteModel: DELETE('api/v1/imageClassification/{id}', ImageClassificationModel),

    /** Download an image classifier model as a BLOB */
    download: GET.blob('api/v1/imageClassification/download/{fileName}'),
};
